/** Normaliza teléfono mexicano a formato internacional para wa.me (sin +). */
function normalizeWhatsAppDigits(phone) {
  const digits = String(phone || '').replace(/\D/g, '');
  if (!digits) return '';
  if (digits.length === 10) return `52${digits}`;
  return digits;
}

/** Enlace wa.me — abre WhatsApp en móvil y escritorio. */
export function buildWhatsAppUrl(phone, message = '') {
  const normalized = normalizeWhatsAppDigits(phone);
  if (!normalized) return 'https://wa.me/';
  const base = `https://wa.me/${normalized}`;
  const text = String(message || '').trim();
  if (!text) return base;
  return `${base}?text=${encodeURIComponent(text)}`;
}
